import React, { Component } from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import LoadingCube from 'sub_components/Common/LoadingCube';
import { RESOLUTIONS } from 'services/config';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const dueIcon = `${CDN_URL}billing/due-icon.svg`;
const overdueIcon = `${CDN_URL}billing/icon_Invoice_pastdue.svg`;
const paidIcon = `${CDN_URL}billing/invoice-icon-paid.svg`;
const NUM_INVOICES_TO_SHOW = {
	[RESOLUTIONS.LOW]: 2,
	[RESOLUTIONS.MED]: 3,
	[RESOLUTIONS.HIGH]: 3,
};

class RecentInvoices extends Component {
	constructor(props) {
		super(props);

		this.state = {
			invoicesToDisplay: null,
			screenWidth: null,
			invoices: null,
			loading: true,
		};
	}

	getIcon = status => {
		switch (status) {
			case 'Paid':
				return paidIcon;
			case 'Overdue':
				return overdueIcon;
			default:
				return dueIcon;
		}
	};

	formatAmount = amount => {
		const number = amount.toString();
		let newArray = [];

		if (number.includes('.')) {
			newArray = number.split('.');
		}

		return (
			<>
				<span className='dollar numbers5'>$</span>
				<span className='dollars numbers20'>{newArray[0] ? newArray[0] : amount}</span>
				<span className='cents numbers5'>{newArray[1] ? newArray[1] : '00'}</span>
			</>
		);
	};

	renderRecentInvoices = invoices => {
		const { breakpoint, navigate } = this.props;
		let invoiceList = [];
		for (let i = 0; i < NUM_INVOICES_TO_SHOW[breakpoint]; i++) {
			const invoice = invoices[i];
			if (invoice) {
				const invoiceDate = format(new Date(invoice.billcycle), 'MM.dd.yy');
				const invoiceNumber = invoice.invoice_number ? invoice.invoice_number : '';

				invoiceList = this.getInvoiceList(
					invoiceList,
					invoice,
					invoiceDate,
					invoiceNumber,
					navigate,
				);
			}
		}

		return invoiceList;
	};

	getInvoiceList = (invoiceList, invoice, invoiceDate, invoiceNumber, navigate) => {
		invoiceList.push(
			<div
				key={invoice.invoiceid}
				className='recent-invoice'
				onClick={() =>
					navigate('/portal/billing/invoice_history', {
						state: { invoiceNumber: invoice.invoice_number },
					})
				}
			>
				<div className='invoice-image image'>
					{invoice.status && <img src={this.getIcon(invoice.status)} />}
				</div>
				<span className={`invoice-amount${invoice.status === 'Overdue' ? ' overdue' : ''}`}>
					{invoice.amount_due ? this.formatAmount(invoice.amount_due) : ''}
				</span>
				<span className='invoice-number body10'>
					{invoice.invoice_number ? `Invoice: #${invoiceNumber}` : ''}
				</span>
				<span className='date-sent invoice-date body10'>
					{invoice.billcycle ? `Date Sent: ${invoiceDate}` : ''}
				</span>
			</div>,
		);
		return invoiceList;
	};

	render() {
		const { loading, invoices } = this.props;

		return (
			<>
				{invoices && (
					<div className={'recent-invoices-wrapper recent-invoices'}>
						<div className='invoices invoice-list'>{this.renderRecentInvoices(invoices)}</div>
					</div>
				)}
				{loading && !invoices && <LoadingCube />}
			</>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
		company_info: state.company_info,
	};
}

export default connect(mapStateToProps)(RecentInvoices);
